var _circle, _circle2, _ellipse, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivitySessionEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.086,
    cy: 26.5,
    r: 26.5,
    fill: "url(#a)",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.086,
    cy: 26.5,
    r: 25.97,
    stroke: "url(#b)",
    strokeOpacity: 0.1,
    strokeWidth: 1.06
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 53,
    height: 53
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.616,
    cy: 26.5,
    rx: 25.97,
    ry: 26.5,
    fill: "#F5F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.056 26.5c0 14.353-11.4 25.97-25.44 25.97-14.04 0-25.44-11.617-25.44-25.97 0-14.353 11.4-25.97 25.44-25.97 14.04 0 25.44 11.617 25.44 25.97Z",
    stroke: "url(#c)",
    strokeOpacity: 0.1,
    strokeWidth: 1.06
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13.875,
    y: 10.598,
    width: 64.66,
    height: 30.74,
    rx: 7.42,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.345,
    y: 11.128,
    width: 63.6,
    height: 29.68,
    rx: 6.89,
    stroke: "url(#e)",
    strokeOpacity: 0.1,
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12.815 25.438h62.54v8.48a6.36 6.36 0 0 1-6.36 6.36h-49.82a6.36 6.36 0 0 1-6.36-6.36v-8.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-12.815 25.438h62.54v8.48a6.36 6.36 0 0 1-6.36 6.36h-49.82a6.36 6.36 0 0 1-6.36-6.36v-8.48Z",
    fill: "url(#f)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.815 24.378h62.54v2.12h-62.54v-2.12Zm62.54 15.9h-62.54 62.54Zm-62.54 0v-14.84 14.84Zm62.54-14.84v14.84-14.84Z",
    fill: "url(#g)",
    fillOpacity: 0.1,
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8.575,
    y: 16.471,
    width: 26.5,
    height: 4.24,
    rx: 2.12,
    fill: "url(#i)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8.045,
    y: 17.001,
    width: 25.44,
    height: 3.18,
    rx: 1.59,
    stroke: "url(#j)",
    strokeOpacity: 0.1,
    strokeWidth: 1.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.914,
    cy: 20.289,
    rx: 1.656,
    ry: 0.414,
    fill: "#0BCEBB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.267 15.467a3.128 3.128 0 1 0 0 6.257 3.128 3.128 0 0 0 0-6.257Zm-.692 1.901c.037 0 .075.009.11.027l1.885.993c.077.04.125.12.125.208a.233.233 0 0 1-.125.207l-1.885.992a.235.235 0 0 1-.344-.207v-1.985a.233.233 0 0 1 .234-.235Z",
    fill: "#0BCEBB"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 41.28,
    cy: 18.592,
    r: 3.127,
    fill: "url(#m)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.217,
    y: 31.221,
    width: 12.72,
    height: 2.035,
    rx: 1.018,
    fill: "url(#n)",
    fillOpacity: 0.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.15 15.6a2.165 2.165 0 1 0 0-4.33 2.165 2.165 0 0 0 0 4.33Z",
    fill: "url(#o)",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.017 13.435a1.868 1.868 0 1 1-3.735 0 1.868 1.868 0 0 1 3.735 0Z",
    stroke: "url(#p)",
    strokeOpacity: 0.15,
    strokeWidth: 0.595
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.318 7.098a1.479 1.479 0 1 0 0-2.957 1.479 1.479 0 0 0 0 2.957Z",
    fill: "url(#q)",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 5.62a1.181 1.181 0 1 1-2.363 0 1.181 1.181 0 0 1 2.362 0Z",
    stroke: "url(#r)",
    strokeOpacity: 0.15,
    strokeWidth: 0.595
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.682 17.134a1.479 1.479 0 1 0 0-2.958 1.479 1.479 0 0 0 0 2.958Z",
    fill: "url(#s)",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.863 15.655a1.181 1.181 0 1 1-2.362 0 1.181 1.181 0 0 1 2.362 0Z",
    stroke: "url(#t)",
    strokeOpacity: 0.15,
    strokeWidth: 0.595
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.429 49.297a2.746 2.746 0 1 0 0-5.492 2.746 2.746 0 0 0 0 5.492Z",
    fill: "url(#u)",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.877 46.551a2.449 2.449 0 1 1-4.897 0 2.449 2.449 0 0 1 4.897 0Z",
    stroke: "url(#v)",
    strokeOpacity: 0.15,
    strokeWidth: 0.595
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 86.705,
    y1: 26.5,
    x2: 19.241,
    y2: 28.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 86.705,
    y1: 26.5,
    x2: 19.241,
    y2: 28.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 86.142,
    y1: 26.5,
    x2: 20.027,
    y2: 28.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 85.09,
    y1: 25.968,
    x2: 2.947,
    y2: 30.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 82.905,
    y1: 32.858,
    x2: 4.061,
    y2: 40.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 82.905,
    y1: 32.858,
    x2: 4.061,
    y2: 40.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 31.984,
    y1: 18.591,
    x2: -1.022,
    y2: 23.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 31.984,
    y1: 18.591,
    x2: -1.022,
    y2: 23.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 47.725,
    y1: 18.592,
    x2: 39.765,
    y2: 18.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 25.686,
    y1: 32.238,
    x2: 9.843,
    y2: 34.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 64.612,
    y1: 13.435,
    x2: 59.1,
    y2: 13.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 64.612,
    y1: 13.435,
    x2: 59.1,
    y2: 13.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 66.366,
    y1: 5.619,
    x2: 62.601,
    y2: 5.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 66.366,
    y1: 5.619,
    x2: 62.601,
    y2: 5.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 4.73,
    y1: 15.655,
    x2: 0.965,
    y2: 15.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 4.73,
    y1: 15.655,
    x2: 0.965,
    y2: 15.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 10.089,
    y1: 46.551,
    x2: 3.097,
    y2: 46.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 10.089,
    y1: 46.551,
    x2: 3.097,
    y2: 46.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(28.525 14.838)",
    d: "M0 0h7.508v7.508H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 27.117,
    y: 15.734,
    width: 11.594,
    height: 9.109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.07,
    result: "effect1_foregroundBlur_6448_8194"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySessionEmpty);
export default __webpack_public_path__ + "static/media/activity-session-empty.a5c1d3841f51966c9b454001b1c0406208e8488acf307aede1ef925a0447d9eb.svg";
export { ForwardRef as ReactComponent };